// extracted by mini-css-extract-plugin
module.exports = {"page-container":"shared-PageContent-page-container-a4d388db","pageContainer":"shared-PageContent-page-container-a4d388db"};